import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiChatWindowService {
  private readonly openSubject = new BehaviorSubject<boolean>(false);

  readonly isOpen$ = this.openSubject.asObservable();

  toggle() {
    this.openSubject.next(!this.openSubject.value);
  }
}
